import React from 'react'
import styled from 'styled-components'
import ItemGrid from './ItemGrid'

const Grid = styled.div`
    display: flex;
    flex-wrap: wrap;
`

class RecordGrid extends React.Component {
    render() {
        return (
            <Grid>
                {this.props.data && this.props.data.map((item, index) =>
                    <ItemGrid
                        key={item.name}
                        item={item}
                        handleUpdateValue={this.props.handleUpdateValue}
                        isDesigner={this.props.permissions.Designer}
                        mobile={this.props.mobile}
                        fetchRenameCol={this.props.fetchRenameCol}
                        handleFocus={this.props.handleFocus}
                    />
                )}
            </Grid>
        )
    }
}

export default RecordGrid
